module.exports = __webpack_public_path__ + "static/img/process@2x.25e9db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/process@2x.png
// module id = IXkB
// module chunks = 1